import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Card,
  Drawer,
  Group,
  LoadingOverlay,
  Modal,
  ScrollArea,
  useMantineTheme,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { DEL_VEHICLE } from "apollo/mutuations";
import EditIcon from "@mui/icons-material/Edit";

import { GET_VEHICLES } from "apollo/queries";
import B2bTable from "components/reusable/b2bTable";
import { customLoader } from "components/utilities/loader";
import VehicleAddModal from "components/Vehicle/VehicleAddModal";
import VehicleEditModal from "components/Vehicle/VehicleEditModal";
import { useEffect, useState } from "react";
import { Edit, Trash } from "tabler-icons-react";
import Controls from "components/controls/Controls";
import ActionButton from "components/controls/ActionButtonNew";

const Vehicles = () => {
  const [size, setSize] = useState("10");
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [hasMounted, setHasMounted] = useState(false);
  const [openedEdit, setOpenedEdit] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [confirmedSearch, setConfirmedSearch] = useState("");

  const [opened, setOpened] = useState(false);
  const [editId, setEditId] = useState();
  const [deleteID, setDeleteID] = useState(false);
  const [openedDelete, setOpenedDelete] = useState(false);

  const theme = useMantineTheme();

  const { data, loading, fetchMore, refetch } = useQuery(GET_VEHICLES, {
    // fetchPolicy: "no-cache",
    variables: {
      first: parseInt(size),
      page: activePage,
      ordered_by: [
        {
          column: "CREATED_AT",
          order: "DESC",
        },
      ],
      search: searchValue,
    },
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message: error?.graphQLErrors?.[0]?.message || "Failed to get Vehicles",
      });
    },
  });

  const [delVehicle] = useMutation(DEL_VEHICLE, {
    update(cache, { data: { deleteVehicle } }) {
      cache.updateQuery(
        {
          query: GET_VEHICLES,
          variables: {
            first: 10,
            page: activePage,
            search: "",
            ordered_by: [
              {
                column: "CREATED_AT",
                order: "DESC",
              },
            ],
          },
        },
        (data) => {
          if (data.vehicles.data.length === 1) {
            setTotal(total - 1);
            setActivePage(activePage - 1);
          } else {
            return {
              vehicles: {
                data: [
                  ...data.vehicles.data.filter(
                    (vehicle) => vehicle.id !== deleteVehicle.id
                  ),
                ],
              },
            };
          }
        }
      );
    },
  });

  useEffect(() => {
    setHasMounted(true);
  }, []);

  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
  };
  useEffect(() => {
    if (data) {
      setTotal(data.vehicles.paginatorInfo.lastPage);
    }
  }, [data, size]);
  useEffect(() => {
    refetch();
  }, []);
  const handleChange = (currentPage) => {
    fetchMore({
      variables: {
        first: parseInt(size),
        page: currentPage,
      },
    });
    setActivePage(currentPage);
  };

  if (!hasMounted) {
    return null;
  }

  const headerData = [
    {
      label: "Owner Name",
      key: "owner_name",
      sortable: true,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.owner_name}</span>;
      },
    },
    {
      label: "Vehicle Type",
      key: "vehicle_type",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.vehicle_type.title}</span>;
      },
    },
    {
      label: "Plate Number",
      key: "plate_number",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.plate_number}</span>;
      },
    },
    {
      label: "Driver",
      key: "driver",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return (
          <span>
            {" "}
            {rowData.driver !== null
              ? rowData.driver?.user?.name
              : "Not Assigned"}
          </span>
        );
      },
    },
    {
      label: "Actions",
      key: "actions",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return (
          <div style={{ display: "flex", gap: "6px" }}>
            <ActionButton
              label="Edit"
              onClick={() => handleEditProduct(`${rowData.id}`)}
            >
              <EditIcon style={{ fontSize: "1rem" }} />
            </ActionButton>

            <ActionButton
              color="error"
              label="Delete"
              onClick={() => handleDelete(`${rowData.id}`)}
            >
              <Trash size={17} />
            </ActionButton>
          </div>
        );
      },
    },
  ];



  const handleDelete = (id) => {
    setOpenedDelete(true);
    setDeleteID(id);
  };

  const deleteVehicle = () => {
    delVehicle({
      variables: { id: deleteID },
      onCompleted() {
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "green",
          title: "Success",
          message: "Vehicle Deleted Successfully",
        });
      },

      onError(error) {
        setOpenedDelete(false);
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to delete Vehicle",
        });
      },
    });
  };

  const handleEditProduct = (id) => {
    setOpenedEdit(true);
    setEditId(id);
  };

  const handleManualSearch = (searchTerm) => {
    setSearchValue(searchTerm);
  };
  const clearInput = () => {
    setSearchValue("");
    setConfirmedSearch("");
  };

  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <div style={{ width: "98%", margin: "auto" }}>
      <Modal
        opened={openedDelete}
        onClose={() => setOpenedDelete(false)}
        title="Warning"
        centered
      >
        <p>Are you sure do you want to delete this vehicle?</p>
        <Group position="right">
          <Button onClick={() => deleteVehicle()} color="red">
            Delete
          </Button>
        </Group>
      </Modal>
      <Drawer
        opened={openedEdit}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        onClose={() => setOpenedEdit(false)}
        title="Editing a Vehicle"
        padding="xl"
        size="80%"
        position="bottom"
      >
        <VehicleEditModal
          openedEdit={openedEdit}
          setOpenedEdit={setOpenedEdit}
          editId={editId}
        />
      </Drawer>
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        title="Addding a Vehicle"
        padding="xl"
        size="80%"
        position="bottom"
      >
        <VehicleAddModal
          total={total}
          setTotal={setTotal}
          activePage={activePage}
          setActivePage={setActivePage}
          setOpened={setOpened}
        />
      </Drawer>
      <Card shadow="sm" p="lg">
        <ScrollArea>
          <B2bTable
            total={total}
            activePage={activePage}
            handleChange={handleChange}
            clearInput={clearInput}
            handelSearch={handleManualSearch}
            searchValue={confirmedSearch}
            onSearchChange={setConfirmedSearch}
            header={headerData}
            loading={loading}
            data={data ? data.vehicles.data : []}
            size={size}
            handlePageSizeChange={handlePageSizeChange}
          />
        </ScrollArea>
      </Card>
    </div>
  );
};

export default Vehicles;
